module.exports = __webpack_public_path__ + "img/book.654c7505.png";